import {
  createRouter,
  createRootRoute,
  createRoute,
} from '@tanstack/react-router'

import { RootLayout } from './routes/__root'
import { HomePage } from './routes/index'
import { LinkwatchPage } from './routes/linkwatch'

// ── Root route (wraps all pages with layout) ──
const rootRoute = createRootRoute({
  component: RootLayout,
})

// ── Page routes ──
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
})

const linkwatchRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/linkwatch',
  component: LinkwatchPage,
})

// ── Route tree ──
const routeTree = rootRoute.addChildren([
  indexRoute,
  linkwatchRoute,
])

// ── Router ──
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
})

// ── Type registration ──
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
